import {
    USERLEAVETRANSACTION_GET_MULTIPLE,
    USERLEAVETRANSACTION_GET_ONE,
    USERLEAVETRANSACTION_REGISTER_SUCCESS,
    USERLEAVETRANSACTION_REGISTER_FAIL,
    USERLEAVETRANSACTION_LOADING,
    USERLEAVETRANSACTION_LOADING_ERROR,
    USERLEAVETRANSACTION_ACTIVATE_FAIL,
    USERLEAVETRANSACTION_ACTIVATE_SUCCESS,
    USERLEAVETRANSACTION_UPDATE_SUCCESS,
    USERLEAVETRANSACTION_UPDATE_FAIL,
    USERLEAVETRANSACTION_DELETE_SUCCESS,
    USERLEAVETRANSACTION_DELETE_FAIL,
    USERLEAVETRANSACTION_EDIT
} from "../types/userleavetransaction";

let userleavetransactionStore = JSON.parse(localStorage.getItem('userleavetransaction'))

const initialState = {
    isLoading: false,
    userleavetransactions: userleavetransactionStore ? userleavetransactionStore : [],
    userleavetransaction:{},
    msg: null,
    isEdit:-1,
    ref:null,
}

const changeState = (aluu, actid) =>
{
    let newUserleavetransaction = [...aluu];
    newUserleavetransaction.forEach(alu => {
        if(alu.id == actid.id){
            alu.is_active = actid.is_active
        }
    });
    return newUserleavetransaction;
}


export default function(state = initialState, action){
    switch (action.type) {
        case USERLEAVETRANSACTION_EDIT:
            return {
                ...state,
                isEdit : action.payload
        };
        case USERLEAVETRANSACTION_LOADING:
            return {
                ...state,
                isLoading : true
            };
        case USERLEAVETRANSACTION_GET_MULTIPLE:
            localStorage.setItem('userleavetransaction', JSON.stringify(action.payload));
            return {
                ...state,
                userleavetransactions : action.payload,
                msg:'DONE!!!'
            };
        case USERLEAVETRANSACTION_GET_ONE:
            let all = [...state.userleavetransactions];
            let ses = all.filter(row=>row.id == action.payload)[0];
            return {
                ...state,
                userleavetransaction : ses,
                MSG:"DONE!!!"
            };
        case USERLEAVETRANSACTION_REGISTER_SUCCESS:
            localStorage.setItem('userleavetransaction', JSON.stringify([...state.userleavetransactions, action.payload]));
            return {
                ...state,
                userleavetransactions: [...state.userleavetransactions, action.payload],
                msg:action.msg
            }; 
        case USERLEAVETRANSACTION_ACTIVATE_SUCCESS:
            let ac = changeState(state.userleavetransactions, action.payload);
            localStorage.setItem('userleavetransaction', JSON.stringify(ac));
            return{
                ...state,
                msg:'DONE!!!',
                userleavetransactions: ac
            }
        case USERLEAVETRANSACTION_DELETE_SUCCESS:
            let rem = state.userleavetransactions.filter(cat => cat.id != action.payload);
            localStorage.setItem('userleavetransaction', JSON.stringify(rem));
            return{
                ...state,
                msg:'DONE!!!',
                userleavetransactions: rem
            }
        case USERLEAVETRANSACTION_UPDATE_SUCCESS:
            const findInd = state.userleavetransactions.findIndex(cat => cat.id == action.payload.id);
            let newState = [...state.userleavetransactions];
            newState[findInd] = action.payload;
            localStorage.setItem('userleavetransaction', JSON.stringify(newState));
            return {
                ...state,
                ...action.payload,
                userleavetransactions : newState,
                userleavetransaction:action.payload
            }; 
        case USERLEAVETRANSACTION_LOADING_ERROR:
        case USERLEAVETRANSACTION_ACTIVATE_FAIL:
        case USERLEAVETRANSACTION_REGISTER_FAIL:
        case USERLEAVETRANSACTION_DELETE_FAIL:
        case USERLEAVETRANSACTION_UPDATE_FAIL:

            return {
                ...state,
                isLoading: false,
                msg: action.msg
            };
        default:
            return state;
    }

}